import { Box, Checkbox, Typography } from '@mui/material';
import { get } from 'lodash';
import i18n from '../../i18n';
import {
    PERMISSION_BACKSTAGE_ITEMS,
    PERMISSION_MANAGER_ITEMS,
    PERMISSION_PAYMENT_ITEMS,
} from './permission-settings-config';
import type { EmployeePermissionClassRow } from './permission-settings.types';

export type PermissionSettingsMatrixProps = {
    /** 表单勾选态（`normalizeRowForForm` 后） */
    formState: EmployeePermissionClassRow;
    /** Checkbox 勾选变更 */
    onToggle: (key: string, checked: boolean) => void;
    /** 矩阵外层 className，默认权限设置页样式 */
    matrixClassName?: string;
    /** 单格 checkbox id 前缀，避免同页多矩阵 id 冲突 */
    checkboxIdPrefix?: string;
};

/**
 * 岗位权限设置矩阵（收银 / 经理 / 后台），与权限设置页、岗位设置例外弹窗共用。
 */
export default function PermissionSettingsMatrix(props: PermissionSettingsMatrixProps) {
    const {
        formState,
        onToggle,
        matrixClassName = 'permission-settings-page__perm-matrix',
        checkboxIdPrefix = 'permission-settings-cb',
    } = props;

    const renderCheckboxTile = (item: { key: string; labelKey: string }) => (
        <Box
            key={item.key}
            component="label"
            className="permission-settings-page__checkbox-tile"
            htmlFor={`${checkboxIdPrefix}-${item.key}`}
        >
            <Checkbox
                id={`${checkboxIdPrefix}-${item.key}`}
                className="permission-settings-page__checkbox-tile-control"
                disableRipple
                checked={Number(get(formState, item.key, 0)) === 1}
                onChange={(e) => onToggle(item.key, e.target.checked)}
                inputProps={{ 'aria-label': i18n.t(item.labelKey) }}
            />
            <Typography component="span" className="permission-settings-page__checkbox-tile-text">
                {i18n.t(item.labelKey)}
            </Typography>
        </Box>
    );

    const renderMatrixGroup = (titleKey: string, items: readonly { key: string; labelKey: string }[]) => (
        <>
            <Typography component="h3" className="permission-settings-page__perm-matrix-group-title">
                {i18n.t(titleKey)}
            </Typography>
            {items.map((item) => renderCheckboxTile(item))}
        </>
    );

    return (
        <Box className={matrixClassName}>
            {renderMatrixGroup('staff_permission_page_payment', PERMISSION_PAYMENT_ITEMS)}
            {renderMatrixGroup('staff_permission_page_managerPivilege', PERMISSION_MANAGER_ITEMS)}
            {renderMatrixGroup('staff_permission_page_backstage_supporter_function', PERMISSION_BACKSTAGE_ITEMS)}
        </Box>
    );
}
